import React from 'react';
import '../styles/DateDivider.css';

function DateDivider({ date }) {
  const formatDate = (timestamp) => {
    const messageDate = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Сброс времени для корректного сравнения дат
    const resetTime = (date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    };

    const msgDate = resetTime(messageDate);
    const todayDate = resetTime(today);
    const yesterdayDate = resetTime(yesterday);

    if (msgDate.getTime() === todayDate.getTime()) {
      return 'Сегодня';
    }

    if (msgDate.getTime() === yesterdayDate.getTime()) {
      return 'Вчера';
    }

    // Форматирование даты: "15 января 2025"
    const months = [
      'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
      'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];

    const day = messageDate.getDate();
    const month = months[messageDate.getMonth()];
    const year = messageDate.getFullYear();

    // Показываем год только если не текущий
    if (year === today.getFullYear()) {
      return `${day} ${month}`;
    }

    return `${day} ${month} ${year}`;
  };

  return (
    <div className="date-divider">
      <div className="date-divider-line"></div>
      <div className="date-divider-text">{formatDate(date)}</div>
      <div className="date-divider-line"></div>
    </div>
  );
}

export default DateDivider;
